import { createContext, useContext } from 'react';
import { UseCompletableWizardResult } from 'utils/hooks/useCompletableWizard';
import { structuredActivityStepId } from 'domains/structuredActivities/steps';
import { AssignmentFeedback } from 'domains/assignments/types';
import { TypeCustomStructuredActivityFields } from 'types/contentful/clinical';

type CustomStructuredActivityContext = {
  structuredActivityContent: TypeCustomStructuredActivityFields;
  onComplete: (feedbackData: AssignmentFeedback) => void;
  previewMode: boolean;
} & UseCompletableWizardResult;

export const CustomStructuredActivityCtx = createContext({} as CustomStructuredActivityContext);

export const withCustomStructuredActivityContext = (Component: React.FC, matchingStep: structuredActivityStepId) => {
  return (props: Record<string, unknown>) => {
    const { currentStep } = useContext(CustomStructuredActivityCtx);

    if (matchingStep === currentStep) {
      return <Component {...props} />;
    }

    return null;
  };
};
